<template>
	<div class="bottom">
		<div class="footer" :style="{'backgroundColor':bgColor}" :class="border ? 'borderTop' : ''">
			<div class="w1200">
				<div class="footer_down position-relative">
					<div class="left">
						<h3>山东恒达知识产权股份有限公司</h3>
						<p style="color: #fff;">
							市场部：13256314966
						</p>
						<p style="color: #fff;">
							商版部：0631-5678759
						</p>
						<p style="color: #fff;">
							电子邮箱:hengdateam@163.com
						</p>
						<p style="color: #fff;">
							威海恒誉润达专利代理事务所（普通合伙)：0631-5679759
						</p>
					</div>
					<div class="flink">
						<h3>友情链接</h3>
						<p>
							<a href="https://www.cnipa.gov.cn/" target="_blank">国家知识产权局</a>
							<a href="http://amr.shandong.gov.cn/" target="_blank">山东省市场监督管理局</a>
							<a href="http://scjgj.weihai.gov.cn/" target="_blank">威海市市场监督管理局</a>
							<a href="http://chinaip.cnipa.gov.cn/" target="_blank">重点产业专利信息服务平台</a>
						</p>
					</div>
					<div class="right">
						<ul>
							<li>
								<img src="../../../assets/img/footImg/hdzcxy_ewm.jpg" alt="" />
								<h3>恒达知产学苑</h3>
							</li>
							<li>
								<img src="../../../assets/img/footImg/hdzscq_ewm.jpg" alt="" />
								<h3>山东恒达知识产权</h3>
							</li>
						</ul>
					</div>
					<div style="position: absolute;top:250px;left:450px;color: #fff;">
						<div class="pb-1" style="font-size: 16px;font-weight: bold;">总部地址</div>
						<div style="font-size: 14px;padding-bottom: 5px;">山东省威海市高新区火炬创新创业基地A座14层</div>
						<div class="pb-1" style="font-size: 16px;font-weight: bold;">潍坊分公司</div>
						<div style="padding-bottom: 5px;font-size: 14px;">山东省潍坊市奎文区北海路胜利街财富商务大厦2408室</div>
						<div class="pb-1" style="font-size: 16px;font-weight: bold;">济宁分公司</div>
						<div style="font-size: 14px;">山东省邹城市西外环路1888号科技大学工业园区三号综合楼501室</div>
					</div>
				</div>
				<div class="footer_copyright">
					<p><a href="http://beian.miit.gov.cn/" target="_blank" style="color: #fff;">
							鲁ICP备17008703号-1</a> Inc.All rights reserved.</p>
					<p class="beian"><!-- <a href="#"><img src="../../../assets/img/footImg/ba.png" />&nbsp;鲁公网安备
							000000000号</a> --> <a href="#"><img
								src="../../../assets/img/footImg/gs.gif" />&nbsp;威海市市场监督管理局</a></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			bgColor: {
				type: String,
				default: ''
			},
			border: {
				type: Boolean,
				default: false
			}
		},
	}
</script>

<style scoped>
	.w1200 {
		width: 1200px;
		margin: 0 auto;
	}

	.w1200:after {
		content: "";
		width: 0;
		height: 0;
		display: block;
		clear: both;
	}

	.bottom .register {
		background: url(../../../assets/img/footImg/foot_sgin.jpg) no-repeat center top;
		height: 160px;
		padding-top: 70px;
		color: #fff;
	}

	.bottom .register h2 {
		text-align: center;
		font-size: 24px;
	}

	.bottom .register a {
		display: block;
		width: 170px;
		height: 45px;
		line-height: 44px;
		color: #fff;
		background: #14A8FF;
		border-radius: 5px;
		margin: 30px auto;
		font-size: 18px;
		text-align: center;
	}

	.bottom .footer {
		background-color: #f7f7f7;
	}

	.borderTop {
		border-top: 1px solid #eee;
	}

	.bottom .footer .w1200 {
		padding: 0 10px
	}

	.bottom .footer .footer_top ul li {
		float: left;
		width: 278px;
		height: 78px;
		line-height: 78px;
		border: 1px solid #333;
		text-indent: 98px;
		color: #fff;
		margin-right: 20px;
	}

	.bottom .footer .footer_top ul li:last-child {
		margin-right: 0;
	}

	.bottom .footer .footer_top:after,
	.bottom .footer .footer_down:after {
		content: "";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
		overflow: hidden;
	}

	.bottom .footer .footer_top ul li:nth-child(1) {
		background: url(../../../assets/img/footImg/foot_icon1.png) no-repeat 34px center;
	}

	.bottom .footer .footer_top ul li:nth-child(2) {
		background: url(../../../assets/img/footImg/foot_icon2.png) no-repeat 34px center;
	}

	.bottom .footer .footer_top ul li:nth-child(3) {
		background: url(../../../assets/img/footImg/foot_icon3.png) no-repeat 34px center;
	}

	.bottom .footer .footer_top ul li:nth-child(4) {
		background: url(../../../assets/img/footImg/foot_icon4.png) no-repeat 34px center;
	}

	.bottom .footer .footer_tel {
		border-bottom: 1px solid #333;
		height: 90px;
		margin: 0 auto;
		width: 1180px;
		padding-top: 30px;
		color: #aaa;
	}

	.bottom .footer .footer_tel .tel {
		float: left;
		font-size: 16px;
		width: 180px;
		height: 65px;
		background: url(../../../assets/img/footImg/foot_icon5.png) no-repeat 30px 0;
		padding-left: 100px;
	}

	.bottom .footer .footer_tel ul li {
		height: 90px;
		line-height: 60px;
		display: inline-block;
		padding: 0 20px;
	}

	.bottom .footer .footer_tel ul li:first-child {
		padding-left: 0;
	}

	.bottom .footer .footer_down {
		padding-top: 50px;
	}

	.bottom .footer .footer_down .left {
		float: left;
		width: 450px;
		padding-right: 20px;
	}

	.bottom .footer .footer_down .left h3,
	.bottom .footer .footer_down .flink h3 {
		font-size: 16px;
		color: #fff;
		font-weight: bold;
	}

	.bottom .footer .footer_down .left p,
	.bottom .footer .footer_down .flink p {
		font-size: 14px;
		padding-top: 20px;
	}

	.bottom .footer .footer_down .left p a,
	.bottom .footer .footer_down .flink p a {
		font-size: 14px;
		color: #fff;
		margin: 0 20px 15px 0;
		white-space: nowrap;
		display: inline-block;
	}

	.bottom .footer .footer_down .left p a:hover,
	.bottom .footer .footer_down .flink p a:hover {
		color: #C32A1A;
	}

	.bottom .footer .footer_down .flink {
		float: left;
		width: 120px;
		padding-right: 20px;
	}

	.bottom .footer .footer_down .right {
		float: right;
	}

	.bottom .footer .footer_down .right ul li {
		float: left;
		width: 120px;
		height: 150px;
		margin-right: 40px;
		text-align: center;
	}

	.bottom .footer .footer_down .right ul li img {
		width: 115px;
		height: 115px;
	}

	.bottom .footer .footer_down .right ul li:last-child {
		margin-right: 0;
	}

	.bottom .footer .footer_down .right ul li h3 {
		color: #fff;
		padding-top: 15px;
		font-weight: normal;
		font-size: 14px;
		text-align: center;
	}

	.bottom .footer .footer_copyright {
		padding: 30px 0;
	}

	.bottom .footer .footer_copyright p {
		line-height: 30px;
		color: #fff;
		font-size: 14px;
	}

	.bottom .footer .footer_copyright p.beian a {
		color: #fff;
		padding-right: 20px;
		display: inline-block;
	}

	.bottom .footer .footer_copyright p.beian a img {
		vertical-align: middle;
	}
</style>
